// Meta (Facebook) Pixel helpers.
// The Pixel ID is read from NEXT_PUBLIC_META_PIXEL_ID. When it is not set
// (or fbq hasn't loaded yet) every call is a safe no-op, so these helpers
// can be sprinkled through the app without guarding each call site.

export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || ''

const canTrack = () =>
  typeof window !== 'undefined' &&
  typeof window.fbq === 'function' &&
  !!META_PIXEL_ID

// Fire a standard Meta event (ViewContent, AddToCart, Purchase, ...).
export const pixelTrack = (event, data) => {
  if (!canTrack()) return
  if (data) {
    window.fbq('track', event, data)
  } else {
    window.fbq('track', event)
  }
}

// Fire a custom (non-standard) event.
export const pixelTrackCustom = (event, data) => {
  if (!canTrack()) return
  if (data) {
    window.fbq('trackCustom', event, data)
  } else {
    window.fbq('trackCustom', event)
  }
}

export const pixelPageView = () => pixelTrack('PageView')
